/* eslint-disable i18next/no-literal-string */
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {WarningLine} from '@dropbox/dig-icons/assets';

import {formatHeadcount} from './wireframeReportFormat';

/** Headcount with no cost profile adds nothing to spend, so say how much is missing. */
export const UnpricedNote = ({fte}: {fte: number}) => (
  <Box display="flex" alignItems="center" columnGap="6" role="note">
    <UIIcon src={WarningLine} size="small" className={atoms({color: 'Warning Base'})} aria-hidden />
    <Text size="small" color="subtle">
      Spend excludes {formatHeadcount(fte)} HC with no cost profile. Assign one on the Wireframe
      Data admin page.
    </Text>
  </Box>
);
